<template>
  <div class="week-grid" ref="trackContainer">
    <div class="timeline-week" v-for="(week, indexW) in weeks" :key="week.weekNumber" :class="{ 'this-week' : week.isCurrentWeek }">
        <div class="timeline-week-number">{{ week.weekNumber }}</div>
        <div class="timeline-week-dates">{{ week.monthName }} - {{week.year}}</div>
        <ol class="timeline-week-days">
        <li class="timeline-day timeline-comment-container"
            v-for="(day, indexD) in week.days"
            :key="day.weekDay"
            :class="{ today: day.isToday, first: day.isFirst, hover: hoverIndexW === indexW && hoverIndexD === indexD}"
            @click="openGroupComment(day)">
      
          <schedule-day-header :day="day"
                               :overAllocations="overAllocations"></schedule-day-header>
          
          <div class="timeline-comment" v-if="hasGroupComment(day)">
            <font-awesome-icon icon="comment" />
          </div>    
        </li>
        </ol>
    </div>
    <div class="timeline-day-highlight" style="left: 144px; display: none;"></div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import ScheduleDayHeader from '../ScheduleDayHeader.vue';

const uniquePrimitive = (value, index, self) => self.indexOf(value) === index;

export default {
  components: { ScheduleDayHeader },
  name: "ScheduleWeekGrid",
  props: {
    selectedDate: {
      type: Date, 
      default() {
        return new Date();
      },
    },
    zoomLevel: {
      type: Number,
      default: 1,
      validator: function (value) {
        // The value must be 1 or 2
        return [1,2].indexOf(value) !== -1;
      },
    },
    overAllocations: {
      type: Array,
      default: () => ([]) // {key: '2021-11-23', value: 'Der er 3 på arbejde, men der skal være 4'}
    },
    showOverAllocations: {
      type: Boolean,
      default() {
        return true;
      }
    },
  },
  data: () => ({
    groupFilter: null,
    holidayLookUp: [],
    hoverIndexW: -1,
    hoverIndexD: -1,
  }),
  created() {
    document.getElementsByTagName("body")[0].addEventListener("mousemove", this.mouseMoving);
  },
  beforeDestroy() {
    document.getElementsByTagName("body")[0].removeEventListener("mousemove", this.mouseMoving);
  },
  computed: {
    ...mapGetters('groupComments', ['groupComments']),
    ...mapGetters('scheduler', ['allocations', 'groups']),
    ...mapGetters("holidayStore", ["holidaysApiState", "holidays"]),
    weeks() {
      var weeks = [];
      
      var startDate = moment.utc(this.selectedDate);
      startDate = startDate.add(-startDate.isoWeekday() + 1, 'days');

      var weeksToGenerate = this.zoomLevel * 8;
      var indexDate = moment.utc(startDate);
      for (let w = 0; w < weeksToGenerate; w++) {
        weeks.push({
            days: [],
            weekNumber: indexDate.week(),
            isCurrentWeek: indexDate.week() === moment().week(),
            month: indexDate.month(),
            monthName: indexDate.format('MMMM'),
            year: indexDate.year(),
          });

        for (let d = 0; d < 7; d++) {
          weeks[w].days.push({
            date: indexDate,
            weekDay: indexDate.isoWeekday(),
            weekDayName: indexDate.format('ddd'),
            day: indexDate.date(),
            isWeekend: indexDate.isoWeekday() > 5,
            isToday: indexDate.isSame(moment(), 'date'),
            isFirst: indexDate.date() === 1,
            hasOverAllocation: null
          });
          // Increment the index date
          indexDate = moment(indexDate).add(1, 'days');
        }
        weeks[w].monthName = this.formatMonths(weeks[w].days.map(q => q.date.format('MMMM')).filter(uniquePrimitive));
      }
      return weeks;
    },
  },
  methods: {
    ...mapActions('groupComments', ['editGroupComment']),
    formatMonths(months) {
      if (months.length === 1) {
        return months[0];
      }
      return months.join(' / ');
    },
    hasGroupComment(day) {
      const dateString = day.date.format('YYYY-MM-DD')
      const index = this.groupComments.findIndex(q => q.date.indexOf(dateString) === 0);
      return (index > -1) ? true : false;
    },
    hasOverAllocation(day) {      

      const dateString = day.date.format('YYYY-MM-DD');
      if(!this.overAllocations || !this.overAllocations.find(o => o.key === dateString)) {
        return null;
      }
      const overAllocation = this.overAllocations.find(o => o.key === dateString);
      return {value: overAllocation.value, style: overAllocation.styles}
    },
    openGroupComment(day) {
      this.editGroupComment(day.date);
    },
    mouseMoving(event) {
      let offsetLeft = this.$refs.trackContainer.offsetLeft;
      let index = Math.floor((event.clientX - offsetLeft) / ((this.zoomLevel === 1) ? 48 : 24));
      if (index >= 0 && index !== this.hoverIndex) {
        const w = Math.floor(index / 7);
        const d = index % 7;
        
        if(this.hoverIndexW !== w) {
          this.hoverIndexW = w;
        }

        if(this.hoverIndexD !== d) {
          this.hoverIndexD = d;
        }
      }
      else if (index < 0) {
        if(this.hoverIndexW !== -1) {
          this.hoverIndexW = -1;
        } 
        
        if(this.hoverIndexD !== -1) {
          this.hoverIndexD = -1;
        }                 
      }
    }
  }
}
</script>
<style>
.icon-warning {
  position: absolute;
  left: 0;
  width: 13px !important;
  z-index: 1;
  height: 13px !important;
}
.tooltip-warning {
  position: absolute;
  left: 1px;
  top: 9px;
  z-index: 1;
  width: 13px !important;
  height: 13px !important;
}



</style>